import { render } from "./add-site.vue?vue&type=template&id=d32a2d88&scoped=true"
import script from "./add-site.vue?vue&type=script&lang=js"
export * from "./add-site.vue?vue&type=script&lang=js"

import "./add-site.vue?vue&type=style&index=0&id=d32a2d88&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d32a2d88"]])

export default __exports__